// extracted by mini-css-extract-plugin
export default {"page":"ExplorerPage_page__BrHH0","handoff":"ExplorerPage_handoff__FPLwT","fadeUpSoft":"ExplorerPage_fadeUpSoft__4Sqit","loadingCard":"ExplorerPage_loadingCard__mNXlb"};